module.exports = __webpack_public_path__ + "img/ico13.063f3d25.svg";